import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";
import withFetchHook from "./withFetchHook";
import ModalButton from "./ModalButton";
import SendSMSModal from "./modals/SendSMSModal";
import { SignUpCodeModal } from "./SignUpCodeModal";

class SignUpCodeButton extends Component {
  state = {
    showModal: false,
    loading: false,
    signUpCode: "",
    signUpCodeCreatedAt: new Date().toISOString(),
  };

  componentDidMount() {
    this.setState({
      signUpCode: this.props.resident.sign_up_code,
      signUpCodeCreatedAt: this.props.resident.sign_up_code_created_at,
    });
  }

  handleOnClick() {
    const { organizationName, resident, signUpGenerationSuccess } = this.props;

    this.setState({ loading: true });

    this.props
      .fetch(
        `/organizations/${organizationName}/residents/${resident.id}/sign_up_code.json`,
        {
          method: "PATCH",
        }
      )
      .then((data) => {
        signUpGenerationSuccess(data.sign_up_code, data.sign_up_code_created_at);
        this.setState({
          loading: false,
          signUpCode: data.sign_up_code,
          showModal: true,
          signUpCodeCreatedAt: data.sign_up_code_created_at,
        });
      });

  }

  render() {
    const { completed, signUpCode, signUpCodeCreated } = this.props;
    return (
      <>
        <SignUpCodeModal
          signUpCode={this.state.signUpCode}
          show={this.state.showModal}
          handleClose={() => this.setState({ showModal: false })}
        />
        <div className="mr-2">
          { completed ? (
            <div className={'d-lg-flex justify-content-center align-items-center'}>
              <span style={{ fontSize: 14 }}>
                <b style={{ fontSize: 14 }}>Sign up code: </b>
                <span className="sign-up-code" style={{ fontSize: 14 }}>{this.state.signUpCode} </span>
              </span>
              <SendSMSModal signupCode={signUpCode} />
              <div style={{ marginTop: '0.5px' }}>
                <ModalButton forceShow resourceName="sendSMS" label="Send SMS" />
              </div>
              <span style={{ fontSize: 14 }}>
                <b style={{ fontSize: 14 }}>Created: </b>
                <span style={{ fontSize: 14 }}>
                  {moment(signUpCodeCreated).format("MM/DD/YYYY")}{" "}
                </span>
              </span>
            </div>
          ) : (
            !this.state.signUpCode ? (
              <Button
                size="sm"
                onClick={this.handleOnClick.bind(this)}
                disabled={this.state.loading}
                className="sign-up-code"
              >
                {this.state.loading ? "Generating..." : "Generate Sign Up Code"}
              </Button>
            ) : (
              <div className={'d-lg-flex justify-content-center align-items-center'}>
              <span style={{ fontSize: 14 }}>
                <b style={{ fontSize: 14 }}>Sign up code: </b>
                  <span className="sign-up-code">{this.state.signUpCode} </span>
                </span>
                <SendSMSModal signupCode={this.state.signUpCode} />
                <div style={{ marginTop: '0.5px' }}>
                  <ModalButton forceShow resourceName="sendSMS" label="Send SMS" />
                </div>
                <span style={{ fontSize: 14 }}>
                  <b style={{ fontSize: 14 }}>Created: </b>
                  <span>
                    {moment(this.state.signUpCodeCreatedAt).format("MM/DD/YYYY")}{" "}
                  </span>
                </span>
              </div>
            )
          ) }
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    resident: state.resident,
    error: state.ui.signUpCodeModal.error,
    organizationName: state.organization.name,
    completed: state.ui.signUpCodeModal.completed,
    signUpCode: state.ui.signUpCodeModal.signUpCode,
    signUpCodeCreated: state.ui.signUpCodeModal.signUpCodeCreated
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signUpGenerationSuccess: (signUpCode, signUpCodeCreated) => dispatch({ type: "SIGN_UP_GENERATION_SUCCESS", payload: { signUpCode, signUpCodeCreated } })
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(SignUpCodeButton)
);
